
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/youtube",
      function () {
        return require("private-next-pages/android/local/youtube/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/youtube"])
      });
    }
  